export const nodes = {
    dailyIncentives: "DAILY_INCENTIVES",
    merchantIncentives: "MERCHANT_INCENTIVES",
    merchantIncentivesMid: "MERCHANT_INCENTIVES_MID",
    invoices: "INVOICES",
};


export const dropDownOptionLabels = {
  0: "Paid",
  1: "Approved",
  2: "Pending",
  3: "Disputed"
};

export const dropDownTypeLabels = {
  status: "Status",
};

export const dropDownOptions = {
  [nodes.invoices]: [
    {
      type: "status",
      options: [0,1,2,3],
    },
  ],
};